module.exports = __webpack_public_path__ + "img/lines.79a498e3.svg";